(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-carousel"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.brand-carousel-slider');

  sliders.forEach(slider => {
    const track = slider.querySelector('.brand-carousel-track');
    const items = slider.querySelectorAll('.brand-carousel-item');
    const desktopCount = parseInt(slider.dataset.desktop);
    const mobileCount = parseInt(slider.dataset.mobile);
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed) * 1000 || 4000;

    // Definir cuántas marcas se muestran
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const visible = isMobile ? mobileCount : desktopCount;

    track.style.setProperty('--brands-visible', visible);
    track.style.setProperty('--brands-visible-mobile', mobileCount);

    // Autoplay
    if (autoplay) {
      let offset = 0;
      setInterval(() => {
        offset -= 1;
        if (Math.abs(offset) > track.scrollWidth / 2) offset = 0;
        track.style.transform = `translateX(${offset}px)`;
      }, 30);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
